module.exports = __webpack_public_path__ + "img/ip-header-ideenparty.11f00ec7.svg";